// Tries to apply all event handler props
const addEventHandlers = (props) => {
  return {
    onAnimationEnd: props.onAnimationEnd,
    onAbort: props.onAbort,
    onAnimationIteration: props.onAnimationIteration,
    onAnimationStart: props.onAnimationStart,
    onBlur: props.onBlur,
    onCanPlay: props.onCanPlay,
    onCanPlayThrough: props.onCanPlayThrough,
    onChange: props.onChange,
    onClick: props.onClick,
    onCompositionEnd: props.onCompositionEnd,
    onCompositionStart: props.onCompositionStart,
    onCompositionUpdate: props.onCompositionUpdate,
    onContextMenu: props.onContextMenu,
    onCopy: props.onCopy,
    onCut: props.onCut,
    onDoubleClick: props.onDoubleClick,
    onDrag: props.onDrag,
    onDragEnd: props.onDragEnd,
    onDragEnter: props.onDragEnter,
    onDragExit: props.onDragExit,
    onDragLeave: props.onDragLeave,
    onDragOver: props.onDragOver,
    onDragStart: props.onDragStart,
    onDrop: props.onDrop,
    onDurationChange: props.onDurationChange,
    onEmptied: props.onEmptied,
    onEncrypted: props.onEncrypted,
    onEnded: props.onEnded,
    onError: props.onError,
    onFocus: props.onFocus,
    onGotPointerCapture: props.onGotPointerCapture,
    onInput: props.onInput,
    onInvalid: props.onInvalid,
    onKeyDown: props.onKeyDown,
    onKeyPress: props.onKeyPress,
    onKeyUp: props.onKeyUp,
    onLoad: props.onLoad,
    onLoadedData: props.onLoadedData,
    onLoadedMetadata: props.onLoadedMetadata,
    onLoadStart: props.onLoadStart,
    onLostPointerCapture: props.onLostPointerCapture,
    onMouseDown: props.onMouseDown,
    onMouseEnter: props.onMouseEnter,
    onMouseLeave: props.onMouseLeave,
    onMouseMove: props.onMouseMove,
    onMouseOut: props.onMouseOut,
    onMouseOver: props.onMouseOver,
    onMouseUp: props.onMouseUp,
    onPaste: props.onPaste,
    onPause: props.onPause,
    onPlay: props.onPlay,
    onPlaying: props.onPlaying,
    onPointerCancel: props.onPointerCancel,
    onPointerDown: props.onPointerDown,
    onPointerEnter: props.onPointerEnter,
    onPointerLeave: props.onPointerLeave,
    onPointerMove: props.onPointerMove,
    onPointerOut: props.onPointerOut,
    onPointerOver: props.onPointerOver,
    onPointerUp: props.onPointerUp,
    onProgress: props.onProgress,
    onRateChange: props.onRateChange,
    onReset: props.onReset,
    onScroll: props.onScroll,
    onSeeked: props.onSeeked,
    onSeeking: props.onSeeking,
    onSelect: props.onSelect,
    onStalled: props.onStalled,
    onSubmit: props.onSubmit,
    onSuspend: props.onSuspend,
    onTimeUpdate: props.onTimeUpdate,
    onToggle: props.onToggle,
    onTouchCancel: props.onTouchCancel,
    onTouchEnd: props.onTouchEnd,
    onTouchMove: props.onTouchMove,
    onTouchStart: props.onTouchStart,
    onTransitionEnd: props.onTransitionEnd,
    onVolumeChange: props.onVolumeChange,
    onWaiting: props.onWaiting,
    onWheel: props.onWheel,
  };
};

export default addEventHandlers;
